let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("el3pp")).then(() => parcelRequire('ehThj'));